import { useAiTagEffectivenessApi } from '@/common/api/modules/aiTag'
import { tagsPath } from '@/common/app/path'

import TextButton from '@/components/view/atoms/button/TextButton'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import Area from '@/components/view/layouts/area/Area'
import GuidanceAreaContent from '@/components/view/layouts/area/GuidanceAreaContent'
import MessageBar from '@/components/view/molecules/bar/MessageBar'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'

import AITagEffectivenessListTable from './table/AITagEffectivenessListTable'

interface Props {
  siteId: number
}

const AITagEffectivenessTab = ({ siteId }: Props) => {
  const { data, isLoading, error } = useAiTagEffectivenessApi({ site_id: siteId })

  if (isLoading) {
    return <PageListLoading />
  }

  if (error || !data) {
    return (
      <Area tableWrap noBorder>
        <GuidanceAreaContent>
          <Text size={14} color={TextColor.CRITICAL}>
            データの取得に失敗しました
          </Text>
        </GuidanceAreaContent>
      </Area>
    )
  }

  const tags = data.tags ?? []
  const allZero =
    tags.length > 0 &&
    tags.every((t) => t.views_30d === 0 && t.clicks_30d === 0 && t.purchases_30d === 0)

  return (
    <Area tableWrap noBorder>
      {isLoading ? (
        <PageListLoading />
      ) : (
        <>
          {allZero && (
            <MessageBar type='warning' fillIn>
              <Text size={14} weight='bold' color={TextColor.CAUTION}>
                トラッキングデータがありません
              </Text>
              <br />
              <Text size={12}>
                効果スコアの計算には、ECサイトに設置したトラッキングコード（w2smartrec.js）からのユーザー行動データが必要です。
                トラッキングコードが設置されていない場合、全ての数値が0となります。詳しくは
                <TextButton link={tagsPath(siteId)}>埋込みコード一覧画面</TextButton>
                をご確認ください。
              </Text>
            </MessageBar>
          )}
          {tags.length === 0 ? (
            <div className='px-6 py-10 text-center'>
              <Text size={12} color={TextColor.SECONDARY}>
                タグがありません。先にAI解析を実行してください。
              </Text>
            </div>
          ) : (
            <AITagEffectivenessListTable tags={tags} />
          )}{' '}
        </>
      )}
    </Area>
  )
}

export default AITagEffectivenessTab
